module.exports = __webpack_public_path__ + "img/HU10433748.a69c8cf8.png";